import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const studentSchoolsManagement = createApi({
    reducerPath: "studentSchoolsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        studentSchoolsList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/student-schools`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewStudentSchools: builder.mutation({
            query: (schoolId) => ({
                url: `v1/${locale}/settings/student-schools/${schoolId}`,
                method: "GET",
            }),
        }),

        addStudentSchools: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/student-schools`,
                method: "POST",
                body: body,
            }),
        }),

        updateStudentSchools: builder.mutation({
            query: ({ body, schoolId }) => ({
                url: `v1/${locale}/settings/student-schools/${schoolId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteStudentSchools: builder.mutation({
            query: (schoolId) => ({
                url: `v1/${locale}/settings/student-schools/${schoolId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useStudentSchoolsListMutation,
    useDeleteStudentSchoolsMutation,
    useAddStudentSchoolsMutation,
    useViewStudentSchoolsMutation,
    useUpdateStudentSchoolsMutation,
} = studentSchoolsManagement;
